module.exports = __webpack_public_path__ + "media/images/mailer/icon-facebook-footer-e0c5773e595c0ff9b2e066ae6744eb0e.svg";